'use client';

import { useContext } from 'react';
import { useParams } from 'next/navigation';
import type { ThreadPanelLayoutHintScope } from '@/lib/thread-panel-layout-hint';
import { ConfirmedConvexIdentityContext } from '@/providers/workspace-identity-context';

function firstParam(value: string | string[] | undefined): string | null {
  return (Array.isArray(value) ? value[0] : value) ?? null;
}

/** Identity + workspace + thread route that thread presentation hints key on. */
export function useThreadPanelLayoutHintScope(): ThreadPanelLayoutHintScope {
  // Null outside an app router (embedded surfaces, tests): no scope, no hint.
  const params: { orgSlug?: string; id?: string | string[] } | null =
    useParams<{ orgSlug?: string; id?: string | string[] }>();
  return {
    identity: useContext(ConfirmedConvexIdentityContext),
    orgSlug: firstParam(params?.orgSlug),
    threadRouteRef: firstParam(params?.id),
  };
}
